import React, { useEffect, useMemo, useState } from "react";
import "./app.css";
import { api } from "./api";
import type { SummaryItem, SummaryResp } from "./types";
import { EndpointCard } from "./components/EndpointCard";
import logo from "./ault_pulse_logo.svg";

function fmt(tsUnix?: number | null) {
  if (!tsUnix) return "—";
  return new Date(tsUnix * 1000).toLocaleString();
}

export default function App() {
  const [data, setData] = useState<SummaryResp | null>(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    let mounted = true;

    const load = () => {
      setErr("");
      api.summary()
        .then((r) => mounted && setData(r))
        .catch((e) => mounted && setErr(String(e?.message || e)));
    };

    load();
    const t = window.setInterval(load, 60_000);
    return () => {
      mounted = false;
      window.clearInterval(t);
    };
  }, []);

  const items: SummaryItem[] = data?.items || [];
  const anyDown = useMemo(() => items.some((x) => x.last && x.last.ok === false), [items]);

  return (
    <div className="page">
      <div className="container">
        <header className="header">
          <div className="headerLeft"></div>
          <div className="headerCenter">
            <div className="logoTitle">
              <img src={logo} alt="Ault Pulse Logo" className="logo" />
              <div className="h1">AULT Pulse</div>
            </div>
            <div className="muted">Last updated: {fmt(data?.generated_unix)}</div>
          </div>
        </header>

        {err ? <div className="error">Summary load failed</div> : null}

        <div className="grid">
          {items.map((it) => (
            <EndpointCard key={it.endpoint.id} item={it} />
          ))}
        </div>

        <footer className="footer muted">
          Backend checks run every 1 minutes (HTTP HEAD / WS upgrade / TCP connect).
        </footer>
      </div>
    </div>
  );
}
